import API from "./API";

export const DEFAULT_ADDRESS_FIELDS = [
  "fullName",
  "phoneCode",
  "phoneNumber",
  "addressLine1",
  "addressLine2",
  "city",
  "stateProvince",
  "postalCode",
];

export const fetchEnabledCountries = async () => {
  const res = await API.get("/settings/countries");
  return Array.isArray(res?.data?.countries) ? res.data.countries : [];
};

export const fetchCountryAddressFields = async (country) => {
  if (!country) return null;
  const res = await API.get("/settings/country-address-fields", {
    params: { country },
  });
  return res?.data || null;
};
